import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer id="contact" className="footer">
      <h2>Contact Me</h2>
      {/* eslint-disable-next-line */}
      <p>Email: <a href="#">poinguinie@gmail.com</a></p>
    </footer>
  );
};

export default Footer;